import { smetaModals } from "../../MainPage/Tools/modalManager";
import React from "react";
import { getModalSectionID, getStyleWindow } from "../../MainPage/Tools/Tools";
import { resumeRequest } from "../TokenProcessing";
import DialogCert from "../../MainPage/Module/Dialogs/DialogCert";
import Tree from "../../MainPage/Windows/ViewData/Tree/Tree";
import DialogBook from "../../MainPage/Module/Dialogs/DialogBook";

interface Data {
  json: {
    Params: {
      ObjType?: string;
      Module?: string;
      ObjRef?: string;
      RequestID?: string;
      OnlyView?: string;
      MultiSel?: string;
      Level?: string;
      Code?: string;
      RecordIndex?: string;
      Title?: string;
      Path?: string;
      DlgType?: string;
      CanMultiSel?: string;
    };
    CLSID?: string;
    Title?: string;
    Module?: string;
  };
  subData: {
    props: any;
    func: (data: any) => any;
    from: string;
    setInputValue?: () => void;
    setValue?: () => void;
  };
  requestID: string;
}

export const showDataSet = (data: Data) => {
  const { json, subData, requestID } = data;

  if (json.Params) {
    const openDialogCert = () => {
      smetaModals.open(
        <DialogCert
          props={{
            Module: "cert",
            Path: json.Params.Path,
            RecordIndex: json.Params.RecordIndex,
            RequestID: json.Params.RequestID,
            setReturnValue: subData.func,
            SectionID: getModalSectionID(),
            from: subData.from,
          }}
        />,
        {
          Title: json.Params.Title,
          style: getStyleWindow("ShowDataSet"),
          onClose: () => {
            resumeRequest(requestID, subData, {});
          },
        },
      );
    };

    const openDialogTree = () => {
      const onSelectTree = async (tree: any, data: any, selection: any) => {
        if (tree) {
          let item = tree.querySelector(".tree-item-selected");
          if (item) {
            let id = item.id;
            let text = item.querySelector(`#text-tree-item_${id}`).innerText;

            const res = { Result: id, Selection: data.MultiSel && selection };

            resumeRequest(json.Params.RequestID, data, res);

            if (data.input) data.input.dataset.objref = id;
            if (data.setValue) data.setValue({ label: text, id: id });
            if (data.setInputValue) data.setInputValue(text);
          }
        }
      };

      smetaModals.open(
        <Tree
          props={{
            ...subData.props,
            RequestID: requestID,
            CLSID: json.CLSID,
            Module: json.Module,
            SectionID: getModalSectionID(),
            ...json.Params,
            MultiSel: json.Params.MultiSel ? json.Params.MultiSel : json.Params.CanMultiSel,
            ObjRef: json.Params.ObjRef ? json.Params.ObjRef : "0",
            Current: json.Params.ObjRef ? json.Params.ObjRef : "0",
            UsedDate: "0",
            Info: "0",
            Internal: "0",
            showButtons: true,
            setInputValue: subData.setInputValue,
            setValue: subData.setValue,
            onSelect: onSelectTree,
            from: subData.from,
            func: subData.func,
          }}
        />,
        {
          Title: json.Params.Title,
          style: getStyleWindow("ShowDataSet"),
          onClose: () => {
            resumeRequest(requestID, subData, {});
          },
        },
      );
    };

    const openDialogDefault = () => {
      smetaModals.open(
        <DialogBook
          props={{
            ...subData.props,
            from: subData.from,
            func: subData.func,
            Module: json.Module,
            Path: json.Params.Path,
            RequestID: json.Params.RequestID,
            ObjRef: json.Params.RecordIndex,
            selectKey: "RecordIndex",
            SectionID: getModalSectionID(),
          }}
        />,
        {
          Title: json.Params.Title,
          style: getStyleWindow(),
          onClose: () => {
            resumeRequest(requestID, subData, {});
          },
        },
      );
    };

    const dlgType: { [key: string]: () => void } = {
      "1": openDialogCert,
      "2": openDialogTree,
    };

    const type = json.Params.DlgType;
    if (type) dlgType[type]();
    else openDialogDefault();
  }
};
